export default __webpack_public_path__ + "static/media/b21.6aeffbe4.png";